export enum SalesOrderHistoricalFieldsEnum {
	NetworkSalesPersonId = 'NetworkSalesPersonId',
	SalePersonId = 'SalePersonId',
	Status = 'Status'
}